import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { HeroImageComponentType } from "@swo/storefront";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";

export type ToggleT = NonNullable<HeroImageComponentType["toggle"]>;
export type ToggleValue = Pick<ToggleT, "desktopVisualAsset" | "mobileVisualAsset">;

export const HeroImageToggle: ReactTFC<{
  leftLabel: string;
  rightLabel: string;
  toggleValue: "left" | "right";
  onToggle: () => void;
}> = props => {
  return (
    <div
      css={css`
        grid-area: 2/1 / span 1/2;
        align-self: flex-end;
        z-index: 4;

        margin-bottom: 55px;
        ${CSS_MQ.atLeastMd} {
          margin-bottom: 70px;
        }

        display: grid;

        grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
        align-items: center;
        justify-content: center;

        grid-gap: 15px;

        .label {
          font-size: 16px;
          ${CSS_MQ.atLeastMd} {
            font-size: 24px;
          }
        }
      `}
    >
      <span
        className={"label"}
        css={css`
          display: flex;
          justify-content: flex-end;
        `}
      >
        {props.leftLabel}
      </span>
      <button
        onClick={props.onToggle}
        type={"button"}
        css={css`
          --h: 40px;
          --pv: 4px;
          --ph: 4px;
          --x: 2px;
          ${CSS_MQ.atLeastMd} {
            --h: 50px;
            --pv: 5px;
            --ph: 5px;
            --x: 4px;
          }

          --size: calc(var(--h) - 2 * var(--pv));

          height: var(--h);
          width: calc(2 * var(--ph) + 2 * var(--size) + 2 * var(--x));

          background: white;
          box-shadow: 0 0 0px 1px rgb(16 16 16 / 5%);

          border-radius: calc(var(--h) * 0.5);

          padding: var(--pv) var(--ph);
        `}
      >
        <span
          className={props.toggleValue === "right" ? "right" : "left"}
          css={css`
            width: var(--size);
            height: var(--size);

            border-radius: 50%;
            display: block;

            transition: transform 0.3s ease-out, background 0.3s linear;

            &.left {
              transform: translateX(0);
              background: #cd1316;
            }

            &.right {
              transform: translateX(calc(100% + 2 * var(--x)));
              background: ${CSS_COLORS.Green};
            }
          `}
        />
      </button>
      <span
        className={"label"}
        css={css`
          display: flex;
          justify-content: flex-start;
        `}
      >
        {props.rightLabel}
      </span>
    </div>
  );
};
